import { Box, Stack } from '@storyofams/react-ui';
import styled from 'styled-components';

const Tab = styled(Box).attrs(() => ({ as: 'button' }))`
  position: relative;
  color: ${(p) => p.theme.colors.grey700};

  &:after {
    content: '';
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: background-size 0.25s ease-in-out;
    background: linear-gradient(
      ${(p) => p.theme.colors.secondary},
      ${(p) => p.theme.colors.secondary}
    );
    background-size: 0% 2px;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &.active {
    color: ${(p) => p.theme.colors.black};

    &:after {
      background-size: 100% 2px;
    }
  }
`;

export const Tabs = ({ activeTab, setActiveTab, items }) => (
  <Stack space={4} justifyContent={{ sm: 'center' }} overflowX="auto" pb={2}>
    {items?.map(({ title, _uid: id }) => (
      <Tab
        key={id}
        py={1}
        flexShrink={0}
        className={activeTab === id ? 'active' : ''}
        color={activeTab === id ? 'black' : 'grey700'}
        onClick={() => setActiveTab(id)}
      >
        {title}
      </Tab>
    ))}
  </Stack>
);
